
(() => {
  function initPersonalisation(form) {
    if (form.dataset.personalisationReady === 'true') return;

    const field = form.querySelector('[data-personalisation-field]');
    if (!field) return;

    const input = field.querySelector(
      'input[name="properties[Personalisation Name]"]'
    );

    if (!input) return;

    form.dataset.personalisationReady = 'true';

    const counter = field.querySelector('small');

    const root =
      form.closest('.product__info-container') ||
      form.closest('.product') ||
      document;

    function isPersonalised() {
      const selectedOptions = root.querySelectorAll(
        'input[type="radio"]:checked, select[name^="options["]'
      );

      return Array.from(selectedOptions).some((element) =>
        ['personalised', 'personalized'].includes(
          element.value.trim().toLowerCase()
        )
      );
    }

    function updateCounter() {
      if (counter) {
        counter.textContent = `${input.value.length}/20 characters`;
      }
    }

    function updateField() {
      const active = isPersonalised();

      field.hidden = !active;
      input.disabled = !active;
      input.required = active;

      if (!active) {
        input.value = '';
        input.setCustomValidity('');
      }

      updateCounter();
    }

    function validate(event) {
      updateField();

      if (!isPersonalised()) return true;

      if (!input.value.trim()) {
        event.preventDefault();
        event.stopImmediatePropagation();

        input.setCustomValidity(
          'Please enter a name before adding this product to your order.'
        );

        input.reportValidity();
        input.focus();

        return false;
      }

      input.setCustomValidity('');
      return true;
    }

    // Validate standard Add to Cart form submission.
    form.addEventListener('submit', validate, true);

    // Validate Add to Cart buttons.
    form.querySelectorAll(
      'button[name="add"], button[type="submit"]'
    ).forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!validate(event)) return;
      }, true);
    });

    // Validate Buy Now / dynamic checkout buttons.
    const productContainer =
      form.closest('.product__info-container') ||
      form.closest('.product') ||
      form.parentElement;

    if (productContainer) {
      productContainer.addEventListener('click', (event) => {
        const button = event.target.closest(
          '.shopify-payment-button button, ' +
          '.shopify-payment-button__button, ' +
          '[data-testid="Checkout-button"]'
        );

        if (!button) return;
        if (!isPersonalised()) return;

        updateField();

        if (!input.value.trim()) {
          event.preventDefault();
          event.stopImmediatePropagation();

          input.setCustomValidity(
            'Please enter a name before buying this product.'
          );

          input.reportValidity();
          input.focus();
        } else {
          input.setCustomValidity('');
        }
      }, true);
    }

    // Update field when variant options change.
    root.addEventListener('change', (event) => {
      if (
        event.target.matches(
          'input[type="radio"], select[name^="options["]'
        )
      ) {
        updateField();
      }
    });

    input.addEventListener('input', () => {
      input.setCustomValidity('');
      updateCounter();
    });

    // Trim whitespace on change.
    input.addEventListener('change', () => {
      input.value = input.value.trim();
      updateCounter();
    });

    updateField();
  }

  function initAll() {
    document.querySelectorAll('product-form form').forEach(
      initPersonalisation
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Support Shopify theme editor reloads.
  document.addEventListener('shopify:section:load', initAll);
})();
